export enum FormNameEnum {
  linkedQuestionAnswerStackId = 'linkedQuestionAnswerStackId',
}
